module.exports = __webpack_public_path__ + "img/image9.e4b3353e.png";